<template>
  <div class="rl-page">
    <main class="rl-about">
      <section class="rl-hero">
        <div class="rl-container">
          <p class="rl-eyebrow">RED LION BULLION LIMITED</p>
          <h1>关于<span>红狮</span></h1>
          <p class="rl-hero-sub">红狮金业有限公司</p>
          <div class="rl-hero-tags"><span>始于 2010 年</span><span>香港黄金交易所第 81 号行员</span></div>
        </div>
      </section>
      <div class="rl-container rl-breadcrumb"><router-link to="/">首页</router-link><span>/</span>关于红狮</div>
      <div class="rl-container rl-layout">
        <aside class="rl-sidebar">
          <p>关于红狮</p>
          <nav aria-label="页面目录">
            <a href="#rl-section-0" @click.prevent="goTo('rl-section-0')" :class="{ 'is-active': activeSection === 'rl-section-0' }">公司介绍<span>›</span></a>
            <a href="#rl-section-1" @click.prevent="goTo('rl-section-1')" :class="{ 'is-active': activeSection === 'rl-section-1' }">基本信息<span>›</span></a>
            <a href="#rl-section-2" @click.prevent="goTo('rl-section-2')" :class="{ 'is-active': activeSection === 'rl-section-2' }">企业简介<span>›</span></a>
            <a href="#rl-section-3" @click.prevent="goTo('rl-section-3')" :class="{ 'is-active': activeSection === 'rl-section-3' }">发展历程<span>›</span></a>
            <a href="#rl-section-4" @click.prevent="goTo('rl-section-4')" :class="{ 'is-active': activeSection === 'rl-section-4' }">行员资质<span>›</span></a>
            <a href="#rl-section-5" @click.prevent="goTo('rl-section-5')" :class="{ 'is-active': activeSection === 'rl-section-5' }">业务介绍<span>›</span></a>
            <a href="#rl-section-6" @click.prevent="goTo('rl-section-6')" :class="{ 'is-active': activeSection === 'rl-section-6' }">市场资讯<span>›</span></a>
            <a href="#rl-section-7" @click.prevent="goTo('rl-section-7')" :class="{ 'is-active': activeSection === 'rl-section-7' }">交易平台<span>›</span></a>
            <a href="#rl-section-8" @click.prevent="goTo('rl-section-8')" :class="{ 'is-active': activeSection === 'rl-section-8' }">市场研究<span>›</span></a>
            <a href="#rl-section-9" @click.prevent="goTo('rl-section-9')" :class="{ 'is-active': activeSection === 'rl-section-9' }">投资者教育<span>›</span></a>
            <a href="#rl-section-10" @click.prevent="goTo('rl-section-10')" :class="{ 'is-active': activeSection === 'rl-section-10' }">企业发展<span>›</span></a>
            <a href="#rl-section-11" @click.prevent="goTo('rl-section-11')" :class="{ 'is-active': activeSection === 'rl-section-11' }">企业提示<span>›</span></a>
          </nav>
        </aside>
        <article class="rl-article">
          <section class="rl-section" id="rl-section-0" aria-labelledby="rl-title-0">
            <h2 id="rl-title-0"><span>01</span>公司介绍</h2>
            <p>红狮金业有限公司（Red Lion Bullion Limited），简称红狮金业，曾用名香港红狮集团有限公司（Hong Kong Red Lion Capital Limited），是一家在香港注册成立的贵金属交易服务企业，同时开展数字化交易工具、市场研究和投资者教育等相关业务。公司成立于2010年4月26日，2026年6月11日启用现用中英文名称。公司为香港黄金交易所第81号行员（Member No.081），并列入认可电子交易商名单。</p>
            <p>红狮金业围绕黄金、白银及贵金属市场开展相关业务，产品与服务涉及伦敦金、伦敦银，并通过官方网站、移动端应用、PC端及MT4、MT5等交易终端提供行情资讯、交易接入、图表分析和交易管理服务。公司同时开展宏观经济分析、年度研究报告发布、教学视频及分析师直播，形成交易服务、数字化工具与财经内容相结合的业务布局。</p>
          </section>
          <section class="rl-section" id="rl-section-1" aria-labelledby="rl-title-1">
            <h2 id="rl-title-1"><span>02</span>基本信息</h2>
            <dl class="rl-facts">
              <div><dt>中文名</dt><dd>红狮金业有限公司</dd></div>
              <div><dt>外文名</dt><dd>Red Lion Bullion Limited</dd></div>
              <div><dt>简称</dt><dd>红狮金业</dd></div>
              <div><dt>曾用名</dt><dd>香港红狮集团有限公司</dd></div>
              <div><dt>曾用英文名</dt><dd>Hong Kong Red Lion Capital Limited</dd></div>
              <div><dt>成立时间</dt><dd>2010年4月26日</dd></div>
              <div><dt>更名时间</dt><dd>2026年6月11日</dd></div>
              <div><dt>原公司注册编号</dt><dd>1448678</dd></div>
              <div><dt>商业登记号码</dt><dd>52152035</dd></div>
              <div><dt>注册地</dt><dd>中国香港</dd></div>
              <div><dt>业务方向</dt><dd>贵金属交易相关服务</dd></div>
              <div><dt>主要业务</dt><dd>贵金属电子交易相关服务、市场资讯、市场研究、投资者教育</dd></div>
              <div><dt>主要产品</dt><dd>伦敦金、伦敦银</dd></div>
              <div><dt>行员资质</dt><dd>香港黄金交易所第81号行员、认可电子交易商</dd></div>
              <div><dt>服务渠道</dt><dd>官方网站、移动端应用（APP）、网页端（H5）、PC端、MT4、MT5</dd></div>
              <div><dt>业务地址</dt><dd>香港九龙尖沙咀漆咸道南87号百利商业中心15楼1511室</dd></div>
            </dl>
          </section>
          <section class="rl-section" id="rl-section-2" aria-labelledby="rl-title-2">
            <h2 id="rl-title-2"><span>03</span>企业简介</h2>
            <p>红狮金业有限公司的业务围绕黄金、白银及贵金属市场展开，将电子交易相关服务与行情资讯、市场研究、投资者教育相结合，通过网站、移动应用和交易终端提供相关服务。</p>
            <p>公司关注全球宏观经济、主要央行货币政策、美元与利率环境及贵金属供需，通过市场分析、年度研究和线上内容介绍金融市场变化。</p>
          </section>
          <section class="rl-section" id="rl-section-3" aria-labelledby="rl-title-3">
            <h2 id="rl-title-3"><span>04</span>发展历程</h2>
            <ol class="rl-timeline">
              <li><span>2010</span><p>2010年4月26日，公司在香港注册成立。</p></li>
              <li><span>2021</span><p>2021年9月15日，公司采用“香港红狮集团有限公司”及“Hong Kong Red Lion Capital Limited”名称。</p></li>
              <li><span>2026</span><p>2026年6月11日，公司中文名称变更为“红狮金业有限公司”，英文名称变更为“Red Lion Bullion Limited”。公司名称变更后，商业登记号码52152035、原公司注册编号1448678及第81号行员编号延续对应同一公司。</p></li>
            </ol>
          </section>
          <section class="rl-section" id="rl-section-4" aria-labelledby="rl-title-4">
            <h2 id="rl-title-4"><span>05</span>行员资质</h2>
            <p>红狮金业有限公司为香港黄金交易所第81号行员（Member No.081），同时列入认可电子交易商名单。</p>
            <p>公司行员证书载明其拥有在香港黄金交易所参与买卖的权利，并可在符合有关交易条件后申请成为交易所参与者，参与贵金属买卖。</p>
          </section>
          <section class="rl-section" id="rl-section-5" aria-labelledby="rl-title-5">
            <h2 id="rl-title-5"><span>06</span>业务介绍</h2>
            <h3>贵金属电子交易相关服务</h3>
            <p>红狮金业主要围绕伦敦金、伦敦银等贵金属市场提供相关服务。用户可通过电子交易渠道获取市场行情，并依据相关规则进行贵金属交易。</p>
            <p>交易所设有伦敦金、伦敦银合约交易编码机制。符合该登记机制的交易可凭相应编码查询成交价格、成交时间及数量等资料。</p>
            <h3>实物黄金业务历史</h3>
            <p>金银业贸易场保留的历史金条零售行员名单中列有第081号，相关产品包括九九金、九九九九公斤条及五两金条等。</p>
          </section>
          <section class="rl-section" id="rl-section-6" aria-labelledby="rl-title-6">
            <h2 id="rl-title-6"><span>07</span>市场资讯</h2>
            <p>公司提供黄金、白银及宏观金融市场资讯，内容涉及贵金属价格走势、美元与利率环境、主要央行货币政策、贵金属供需、重要经济数据和全球金融市场事件。</p>
          </section>
          <section class="rl-section" id="rl-section-7" aria-labelledby="rl-title-7">
            <h2 id="rl-title-7"><span>08</span>交易平台</h2>
            <p>红狮金业通过官方网站、移动端应用（APP）、网页端（H5）、PC端及MT4、MT5等交易终端提供相关服务，覆盖行情查看、交易接入、图表分析、交易管理及市场资讯获取等功能。</p>
            <p>MT4（MetaTrader 4）和MT5（MetaTrader 5）为电子交易终端，可用于行情查看、图表分析及交易管理。公司网站与移动应用同时承担市场分析、研究报告和投资者教育内容的发布功能。具体平台功能与支持范围以公司当前有效产品资料为准。</p>
          </section>
          <section class="rl-section" id="rl-section-8" aria-labelledby="rl-title-8">
            <h2 id="rl-title-8"><span>09</span>市场研究</h2>
            <p>红狮金业围绕全球贵金属市场及宏观经济开展研究与分析，研究议题涵盖黄金、白银、主要央行货币政策、美元与利率环境、全球资产配置及贵金属市场机会。</p>
            <p>公司及相关研究团队通过市场分析、年度投资机会研究和线上发布活动呈现研究观点。</p>
            <p>2024年12月18日，香港红狮集团与红狮研究院联合财经媒体举办“2025全球投资机会研究报告”线上发布活动，并在APP发布《2025全球投资机会研究报告》，研究议题包括全球经济、股票市场、能源等领域。</p>
            <p>2026年1月14日，香港红狮集团与复投财经举办“2026全球投资机会研究报告”线上发布会，并在红狮APP发布《2026全球投资机会研究报告》，内容涉及贵金属、科技与高端制造及新兴市场等主题。</p>
          </section>
          <section class="rl-section" id="rl-section-9" aria-labelledby="rl-title-9">
            <h2 id="rl-title-9"><span>10</span>投资者教育</h2>
            <p>红狮金业通过网站、APP、PC端、视频及合作媒体等渠道发布投资者教育内容，包括从入门到进阶的网上教学视频、分析师教学直播、行情解读、研究报告和线上交流。</p>
            <p>相关内容涵盖黄金与白银基础知识、贵金属市场运行机制、市场风险识别、宏观经济数据解读、行情分析方法及贵金属交易相关知识。</p>
            <p>公司设置在线咨询及客户服务渠道，提供服务咨询、取款进度跟进和到账通知等支持。</p>
          </section>
          <section class="rl-section" id="rl-section-10" aria-labelledby="rl-title-10">
            <h2 id="rl-title-10"><span>11</span>企业发展</h2>
            <p>红狮金业自2010年成立以来持续围绕贵金属市场开展业务，并随着数字化交易方式的发展逐步拓展官方网站、移动端应用及电子交易终端等线上服务渠道。公司结合年度研究、财经内容和投资者教育开展品牌内容建设。</p>
            <p>2026年，公司启用“红狮金业有限公司”及“Red Lion Bullion Limited”作为现用中英文公司名称，以强化贵金属业务的识别。</p>
          </section>
          <section class="rl-section rl-notice" id="rl-section-11" aria-labelledby="rl-title-11">
            <h2 id="rl-title-11"><span>12</span>企业提示</h2>
            <p>贵金属价格可能受到全球经济、货币政策、美元走势、利率变化、地缘政治及市场流动性等因素影响，相关交易存在市场风险。</p>
            <p>红狮金业相关业务按照适用规则及交易所相关制度开展。第81号为香港黄金交易所行员编号。具体产品规则、交易时间、费用、保证金安排及风险提示，以公司当期有效客户文件及适用交易规则为准。</p>
          </section>
        </article>
      </div>
      <button v-show="showTop" class="rl-backtop" @click="backToTop" aria-label="返回顶部">↑</button>
    </main>
    <base-footer />
  </div>
</template>

<script>
import BaseFooter from '@/component/base-footer';

export default {
  name: 'AboutRedLion',
  metaInfo: {
    title: '关于红狮-红狮金业有限公司',
  },
  components: {
    BaseFooter,
  },
  data() {
    return {
      activeSection: 'rl-section-0',
      showTop: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.showTop = window.scrollY > 500;
      const sections = this.$el.querySelectorAll('.rl-section');
      let current = 'rl-section-0';
      sections.forEach((el) => {
        if (el.getBoundingClientRect().top <= 150) current = el.id;
      });
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atBottom && sections.length) current = sections[sections.length - 1].id;
      this.activeSection = current;
    },
    goTo(id) {
      const el = document.getElementById(id);
      if (el) {
        this.activeSection = id;
        el.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }
    },
    backToTop() {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    },
  },
};
</script>

<style scoped>
.rl-page{padding-top:0}
.rl-about{--rl-red:#fa2314;--rl-ink:#0f0f11;background:#fafafa;color:var(--rl-ink);font-family:Avenir,"Microsoft YaHei","PingFang SC",Arial,sans-serif;font-size:15px;line-height:1.9}
.rl-about *{box-sizing:border-box}
.rl-about a{color:inherit;text-decoration:none}
.rl-about button{font:inherit}
.rl-container{width:min(1240px,calc(100% - 64px));margin:auto}
.rl-hero{height:360px;background:#170609 url('~@/assets/imgs/aboutRedLion/about-banner.png') center/cover no-repeat;display:flex;align-items:center;color:#fff}
.rl-eyebrow{font-size:12px;letter-spacing:3px;opacity:.65;margin:0 0 12px}
.rl-hero h1{font-size:52px;font-weight:600;letter-spacing:4px;line-height:1.3;margin:0 0 12px}
.rl-hero h1 span{color:var(--rl-red)}
.rl-hero-sub{font-size:20px;margin:0}
.rl-hero-tags{display:flex;gap:22px;margin-top:25px;font-size:13px;color:#ddd}
.rl-hero-tags span+span{border-left:1px solid #ffffff40;padding-left:22px}
.rl-breadcrumb{display:flex;gap:12px;padding:24px 0;color:#888;font-size:13px}
.rl-breadcrumb a:hover{color:var(--rl-red)}
.rl-layout{display:grid;grid-template-columns:200px minmax(0,1fr);gap:40px;align-items:start;padding-bottom:80px}
.rl-sidebar{position:sticky;top:104px;background:#fff;border:1px solid #ececec}
.rl-sidebar>p{padding:18px 22px;margin:0;font-size:19px;font-weight:600;border-bottom:1px solid #eee}
.rl-sidebar nav{padding:10px 0}
.rl-sidebar a{display:flex;justify-content:space-between;padding:10px 22px;border-left:3px solid transparent;color:#626262;font-size:14px;cursor:pointer}
.rl-sidebar a span{color:#bbb}
.rl-sidebar a:hover,.rl-sidebar a.is-active{border-left-color:var(--rl-red);color:var(--rl-red);background:#fff5f3}
.rl-article{min-width:0;background:white;padding:8px 44px 40px;border:1px solid #ececec}
.rl-section{padding:32px 0;border-bottom:1px solid #eee;scroll-margin-top:104px}
.rl-section:last-child{border:0}
.rl-section h2{font-size:25px;line-height:1.4;margin:0 0 23px;display:flex;align-items:center;gap:14px;font-weight:600}
.rl-section h2>span{font-size:13px;font-weight:500;color:var(--rl-red);border-right:1px solid #e7e7e7;padding-right:14px;letter-spacing:1px}
.rl-section p{margin:0 0 15px;color:#555;text-align:justify;overflow-wrap:anywhere}
.rl-section p:last-child{margin-bottom:0}
.rl-section h3{font-size:17px;font-weight:600;margin:22px 0 12px}
.rl-facts{margin:0;border:1px solid #eee}
.rl-facts>div{display:grid;grid-template-columns:144px 1fr;border-bottom:1px solid #eee}
.rl-facts>div:last-child{border:0}
.rl-facts dt{padding:11px 18px;background:#f8f8f8;color:#777}
.rl-facts dd{margin:0;padding:11px 20px;overflow-wrap:anywhere;color:#444}
.rl-timeline{list-style:none;margin:0;padding:0}
.rl-timeline li{position:relative;border-left:1px solid #e6e6e6;margin-left:6px;padding:0 0 28px 26px}
.rl-timeline li:last-child{padding-bottom:0}
.rl-timeline li:before{content:'';position:absolute;top:9px;left:-5px;width:9px;height:9px;border-radius:50%;background:var(--rl-red);box-shadow:0 0 0 5px #fff3f0}
.rl-timeline li>span{font-size:24px;color:var(--rl-red);font-weight:600;line-height:1.3}
.rl-timeline p{margin-top:8px}
.rl-notice{margin-top:30px;padding:24px!important;background:#faf7f5;border-left:3px solid var(--rl-red)!important}
.rl-notice h2{font-size:19px;margin-bottom:15px}
.rl-notice p{font-size:13px;line-height:1.9;color:#777}
.rl-backtop{position:fixed;right:22px;bottom:26px;border:1px solid #e4e4e4;background:white;color:#555;width:44px;height:44px;cursor:pointer;border-radius:4px;z-index:20}
.rl-backtop:hover{color:var(--rl-red)}
.rl-about a:focus-visible,.rl-backtop:focus-visible{outline:2px solid var(--rl-red);outline-offset:3px}
@media(max-width:900px){.rl-page{overflow-x:hidden}.rl-layout{grid-template-columns:1fr;gap:20px}.rl-sidebar{position:static;min-width:0}.rl-sidebar>p{display:none}.rl-sidebar nav{display:flex;overflow-x:auto;padding:0}.rl-sidebar a{white-space:nowrap;border-left:0;border-bottom:2px solid transparent;padding:12px 16px}.rl-sidebar a span{display:none}.rl-sidebar a.is-active{border-bottom-color:var(--rl-red)}.rl-article{padding:0 28px 28px}.rl-hero{height:300px}.rl-hero h1{font-size:42px}}
@media(max-width:600px){.rl-container{width:calc(100% - 32px)}.rl-hero{height:260px;background-position:40% center}.rl-hero h1{font-size:36px}.rl-hero-sub{font-size:17px}.rl-eyebrow{font-size:10px;letter-spacing:2px}.rl-hero-tags{gap:10px;font-size:11px;flex-wrap:wrap}.rl-hero-tags span+span{padding-left:10px}.rl-breadcrumb{padding:17px 0}.rl-layout{padding-bottom:35px}.rl-article{padding:0 20px 24px}.rl-section{padding:25px 0;scroll-margin-top:80px}.rl-section h2{font-size:22px}.rl-section p{font-size:14px;line-height:1.95}.rl-facts{overflow-x:auto}.rl-facts>div{grid-template-columns:98px 1fr;min-width:460px}.rl-facts dt,.rl-facts dd{padding:10px 12px;font-size:13px}.rl-notice{padding:16px!important}.rl-backtop{right:12px;bottom:16px}}
@media(prefers-reduced-motion:reduce){html{scroll-behavior:auto!important}}
</style>
